import { NoopScrollStrategy } from "@angular/cdk/overlay";
import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { MatDialog } from "@angular/material/dialog";
import { OVERVIEW_DATEPICKER_FORMATS } from "src/app/global/date-format";
import { LensSide } from "src/app/model/configuration/configuration";
import { featureValuesAsArray, LensOrderItem } from "src/app/model/order/order";
import { CatalogService } from "src/app/utils/catalog.service";
import { ReturnCorrectionDialogComponent } from "../return-correction-dialog/return-correction-dialog.component";
import { ReturnStoreService } from "../return-store.service";

@Component({
    selector: 'app-return-side',
    templateUrl: './return-side.component.html',
    styleUrls: ['./return-side.component.scss'],
    providers: [
        {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
        {provide: MAT_DATE_FORMATS, useValue: OVERVIEW_DATEPICKER_FORMATS},
    ],
})
export class ReturnSideComponent implements OnInit {
    form: FormGroup;

    @Input() side: LensSide;
    @Input() returnItem: LensOrderItem;
    @Output() switchEmit = new EventEmitter<LensSide>();

    LensSide = LensSide;
    storedItem: LensOrderItem;
    storedDescription: string;
    breakagePossible: boolean;
    creditNotePossible: boolean;

    constructor(
        private formBuilder: FormBuilder,
        public dialog: MatDialog,
        private catalogService: CatalogService,
        private returnStoreService: ReturnStoreService
    ) {
    }

    ngOnInit() {
        this.storedItem = this.returnItem;
        this.initFormGroup();
        this.breakagePossible = !this.daysPassed(100, new Date(this.returnItem.deliveryDate));
        this.creditNotePossible = this.returnItem.isReturn && !this.daysPassed(100, new Date(this.returnItem.deliveryDate));
    }

    private initFormGroup() {
        this.form = this.formBuilder.group({
            commission: [this.returnItem.commission],
            chargeNumber: [this.returnItem.chargeNumber],
            description: [this.getCLData()],
            newDescription: [undefined],
            mainRadioGroup: this.formBuilder.group({
                mainRadioGroupOption: [],
                breakageGroup: this.formBuilder.group({
                    breakageRadioGroupOption: [],
                    breakageDeliveryNumber: []
                }),
                wrongDeliveryGroup: this.formBuilder.group({
                    wrongDeliveryRadioGroupOption: [],
                    wrongDeliveryReason: [],
                    wrongDeliveryNumber: []
                }),
                reworkGroup: this.formBuilder.group({
                    reworkIntensive: [false],
                    reworkSurface: [false],
                    reworkDptChange: [false],
                    reworkDptChangeInput: [],
                    reworkDiameterReduction: [false],
                    reworkDiameterReductionInput: [],
                    reworkRemoveEdgeDefect: [false],
                    reworkChangeEdgeLift: [false],
                    reworkChangeEdgeLiftInput: [],
                }),
                inspectionCompliantGroup: this.formBuilder.group({
                    inspectionCompliantFirst: [false],
                    inspectionCompliantSecond: [false],
                    inspectionCompliantThird: [false],
                    inspectionCompliantFourth: [false],
                    inspectionCompliantFifth: [false],
                    inspectionCompliantOther: [],
                    inspectionCompliantRadioGroupOption: [],
                    inspectionCompliantDeliveryNumber: []
                }),
            }),
            callBack: [false],
            callBackGroup: this.formBuilder.group({
                callBackMrsMr: [],
                callBackPhone: [],
                callBackOther: [],
                range: this.formBuilder.group({
                    start: [],
                    end: []
                }),
                callBackDate: []
            }),
        });
    }

    private getCLData(): string {
        let article: string = this.returnItem.article ? this.returnItem.article.name : '';
        let backSide: string = this.returnItem.article.backSide ? this.returnItem.article.backSide.name : '';
        let material: string = this.returnItem.material ? this.returnItem.material.name : '';
        let color: string = this.returnItem.color ? this.returnItem.color.name : '';

        let clData = `${article}, ${backSide}, ${material}, ${color}`;
        featureValuesAsArray(this.returnItem.featureValues).forEach(feature => {
            if(feature.value) {
                this.catalogService.getFeatureTranslation(feature.name).subscribe(data => clData += `, ${data}: ${feature.value}`);
            }
        });
        return clData;
    }

    cancelChanges() {
        if (this.storedDescription) {
            this.storedDescription = undefined;
            this.returnItem = this.storedItem;
            //this.form.controls['commission'].setValue(this.storedItem.commission);
            this.form.controls['newDescription'].setValue(undefined);
        }
    }

    openCorrectionDialog(): void {
        const dialogRef = this.dialog.open( ReturnCorrectionDialogComponent, {
          maxWidth: '570px',
          maxHeight: '100vh',
          data: {returnItem: this.returnItem},
          scrollStrategy: new NoopScrollStrategy()
        });

        dialogRef.afterClosed().subscribe(result => {
            if(result !== undefined) {
                this.returnItem = result;
                this.returnItem.side = this.side;
                this.returnStoreService.setItem(this.returnItem);
                this.form.controls['commission'].setValue(this.returnItem.commission);
                this.storedDescription = this.getCLData();
                this.form.controls['newDescription'].setValue(this.storedDescription);
            }
        });
    }

    switch(side: LensSide) {
        this.switchEmit.emit(side);
    }

    daysPassed(days: number, date: Date): boolean {
        if (this.returnItem.deliveryDate != null) {
          let currentDate = new Date();
          let res = Math.floor((Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()) - Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) ) /(1000 * 60 * 60 * 24));
          return res > days;
        } else {
          return false;
        }
    }
}
